import { auth } from '../firebase/config'
import Formatter from '../helpers/Formatter'
import { useAppDispatch, useAppSelector } from '../state/hooks'
import { setCheckoutState } from '../state/Slices/checkoutSlice'
import { useFirebaseAnalyticsContext } from '../context/FirebaseAnalyticsContext'

export const useToggleConfirmModal = () => {
	const dispatch = useAppDispatch()
	const { logBeginCheckoutAnalytics } = useFirebaseAnalyticsContext()
	const { savedPhone, isConfirmModalVisible, prices, analyticsItems } = useAppSelector(
		state => state.checkout
	)
	const { posLoyaltyEnabled } = useAppSelector(state => state.settings)
	const { receiptPrinter } = useAppSelector(state => state.persisted)

	return () => {
		const email = auth.currentUser ? Formatter.decodedEmail(auth.currentUser.email) : ''
		let phone = savedPhone

		if (savedPhone.length === 11 && savedPhone.startsWith('1')) {
			phone = savedPhone.substring(1)
		}

		if (!isConfirmModalVisible) {
			logBeginCheckoutAnalytics(prices.total, analyticsItems)
		}

		dispatch(
			setCheckoutState({
				selectedMethods: {
					textMessage: false,
					email: false,
					print: global.kiosk && receiptPrinter !== null,
					textUpdates: false,
					showNumPad: false,
					phoneString: global.kiosk ? '' : phone,
					emailString: global.kiosk ? '' : email,
					phoneStringFormatted: global.kiosk ? '' : phone,
				},
				showPOSMethods: global.pos,
				typePOS: '',
				showDineInOrTakeout: true,
				tableNumber: null,
				phoneNumberInput: false,
				showAddTip: !global.kiosk,
				showKioskLoyaltyEntry: posLoyaltyEnabled,
			})
		)

		if (auth.currentUser) {
			dispatch(setCheckoutState({ isGuestCheckout: false }))
		}

		dispatch(setCheckoutState({ isConfirmModalVisible: !isConfirmModalVisible }))
	}
}
